import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { db } from "../firebase/firebase";

import Sidebar from "../components/layout/Sidebar";
import Topbar from "../components/layout/Topbar";
import "./BaseLayout.css";


import "./Historico.css";

export default function HistoricoNotificacoes() {
  const [lista, setLista] = useState([]);

  // Carregar histórico
  const carregar = async () => {
    const snap = await getDocs(collection(db, "notificacoes_historico"));

    let dados = snap.docs.map((d) => {
      const item = d.data();

      // --- TRATAMENTO SEGURO DE DATA ---
      let data = item.dataEnvio;
      if (data?.toDate) {
        data = data.toDate();
      }

      return {
        id: d.id,
        titulo: item.titulo || "(Sem título)",
        mensagem: item.mensagem || "(Sem mensagem)",
        destinatario: item.destinatario || "ALL",
        dataEnvio: data || null,
      };
    });

    // Ordenar: mais recente primeiro
    dados.sort((a, b) => (b.dataEnvio || 0) - (a.dataEnvio || 0));

    setLista(dados);
  };

  const deletarItem = async (id) => {
    if (!window.confirm("Tem certeza que deseja apagar esta notificação?")) return;

    await deleteDoc(doc(db, "notificacoes_historico", id));
    carregar();
  };

  useEffect(() => {
    carregar();
  }, []);

  return (
    <div className="page-wrapper">
      <Sidebar />
      <div className="page-content">
        <Topbar />

        <div className="historico-container">
          <h2>📨 Histórico de Notificações</h2>

          <table className="historico-table">
            <thead>
              <tr>
                <th>Título</th>
                <th>Mensagem</th>
                <th>Destinatário</th>
                <th>Data</th>
                <th>Ações</th>
              </tr>
            </thead>

            <tbody>
              {lista.length === 0 && (
                <tr>
                  <td colSpan="5">Nenhuma notificação enviada ainda.</td>
                </tr>
              )}

              {lista.map((item) => (
                <tr key={item.id}>
                  <td>{item.titulo}</td>
                  <td>{item.mensagem}</td>
                  <td>{item.destinatario}</td>
                  <td>
                    {item.dataEnvio
                      ? item.dataEnvio.toLocaleString()
                      : "Sem data"}
                  </td>
                  <td>
                    <button
                      className="delete-btn"
                      onClick={() => deletarItem(item.id)}
                    >
                      Apagar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}
